2<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    color: #768192;
    border-color: none; 
    border : none;
    background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader class="bg-primary text-white d-flex align-items-center font-weight-bold">
      Pengajuan Professional
    </CCardHeader>
    <CCardBody>
      <CRow>
          <CCol xl="12">
           <div class="form-group float-left">
                    <label for="" class="font-weight-bold">Data Perhalaman</label>
                    <select class="form-control" v-model="pageSize">
                        <option 
                        v-for="(item,idx) in {10:'10', 25:'25', 100:'100', 5000:'Semua Data'}" 
                        v-bind:key="idx" 
                        :value="idx">{{item}}</option>
                    </select>
                </div>
            <div class="form-group float-right">
                    <label for="" class="font-weight-bold">Pencarian</label>
                    <input
                    class="form-control"
                    v-model="search"
                    >
                    
                </div>
            <br />
          </CCol>
        </CRow>
      </CRow>
      <ul
          class="nav nav-tabs bg-active border-0 border-bottom-0"
          id="myTab"
          role="tablist"
      >
        <li class="nav-item" ref="tabInputted">
          <div
            :class="tab_selected.aria_selected_inputted ? 'nav-link p-3 px-4 font-weight-bold text-white active' : 'nav-link p-3 px-4 font-weight-bold text-white'"
            id="home-tab"
            data-toggle="tab"
            href="#home"
            style="cursor: pointer"
            role="tab"
            aria-controls="home"
            @click="tabChange('inputted')"
            :aria-selected="tab_selected.aria_selected_inputted">
            Inputted
            <span class="badge badge-danger text-white">{{ badges.totalInputted }}</span>
          </div>
        </li>
        <li class="nav-item">
          <div
              :class="tab_selected.aria_selected_confirmed ? 'nav-link p-3 px-4 font-weight-bold text-white active' : 'nav-link p-3 px-4 font-weight-bold text-white'"
              id="profile"
              data-toggle="tab"
              href="#profile"
              style="cursor: pointer"
              role="tab"
              aria-controls="profile"
              @click="tabChange('confirmed')"
              :aria-selected="tab_selected.aria_selected_confirmed">
              Confirmed
              <span class="badge badge-success text-white">{{
              badges.totalConfirmed
              }}</span>
          </div>
        </li>
      </ul>
      </Crow>
      <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
        <template #no="{index}">
          <td class="py-2">{{indexed == 0 ? index + 1 : index + indexed + 1}}</td>
        </template>
         <template #email="{item}">
          <td class="py-2">
            {{ item.email }}
          </td>
        </template>
        <template #updated_by="{item}">
          <td class="py-2">
            {{item.updated_by}}
          </td>
        </template>
        <template #created_at="{item}">
          <td class="py-2">
            {{ item.created_at }}
          </td>
        </template>
        <template #updated_at="{item}">
          <td class="py-2">
            {{item.updated_at}}
          </td>
        </template>
        <template #aksi="{item}">
          <td class="py-2 text-center">
            <section v-if="item.status == 1">
              <CButton v-c-tooltip="'Konfirmasi'" color="success" square size="sm" @click="approve(item.idPua)">
                <font-awesome-icon icon="check"/>
              </CButton>
            </section>
            <section v-else>
                <span class="text-info">Confirmed</span>
            </section>
          </td>
        </template>
      </CDataTable>
      <CPagination
        style="float:right"
        :pages="pagination.totalPages"
        :active-page.sync="currentPage"
        responsive
        @click="pageChange"
        v-show="items.length > 0"
      />
      <div class="row">
        <div class="col-6 text-left d-flex align-items-center">
          <div class="font-weight-bold ml-4">{{items.length}} Result Found</div>
        </div>
      </div>
      
    </CCardBody>
  </CCard>
</template>

<script>
import PengajuanUjianProfessionalService from '../../../services/sertifikasi/pengajuan-ujian-professional.service'

const fields = [
  { key: "no" },  
  {
    key: 'notesPua',
    label: 'Keterangan'
  },
   {
    key: 'email',
    label: 'Email'
  },
  {
    key: "createdAt",
    label: 'Created At',
    _style: "text-align: left;"
  },  
  {
    key: "updatedAt",
    label: 'Updated At',
    _style: "text-align: left;"
  },  
  {
    key: "recCreator",
    label : "Rec Creator",
  },
  {
    key: "recEditor",
    label : "Rec Editor",
  },
   {
    key: "aksi",
    _style: "width:20%; text-align: center",
    sorter: false,
    filter: false,
  },
    
];

export default {
  data() {
    return {
      fields,
      tab_selected: {
        aria_selected_inputted: true,
        aria_selected_confirmed: false
      },
      badges: {
        totalInputted: 0,
        totalConfirmed: 0,
      },
      pagination: {
        totalPages: 0
      },
      page: 0, 
      search: '',
      pageSize: 10,
      statusPengajuan:1,
      items:[],
      indexed: 0,
      currentPage: 0,
    }
  },
  mounted() {
    this.getData(this.page,this.pageSize,this.search,this.statusPengajuan);
    this.getTotalCount();
  },
  watch: {
    search: function (val) {
      clearTimeout(this.timeout);
      var vm = this
      this.timeout = setTimeout(function () {
          var searchVar = val.trimStart();
          var searchFinal = searchVar.trimEnd();
          vm.getData(vm.page,vm.pageSize,searchFinal,vm.statusPengajuan)
      }, 1000);
    },
    pageSize: function(val) {
      this.getData(this.page, val, this.search, this.statusPengajuan);
    },
    currentPage: function(val) {
      this.page = val;
      this.getData(val - 1, this.pageSize,this.search, this.statusPengajuan);
      this.getTotalCount();
    },
  },
  methods : {
    getData(currentPage, pageSize, filter, status) {
      
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      PengajuanUjianProfessionalService.getPengajuanLog(currentPage,pageSize,filter, status)
      .then(response => {
        this.items = response.data.content;
        this.pagination.totalPages = response.data.totalPages;
        this.page = response.data.pageable.pageNumber;

        loader.hide()
      }).catch(error => {
        loader.hide()
      })

    },
    approve(id) {
       let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      PengajuanUjianProfessionalService.approve(id, 2)
      .then(response => {
        loader.hide()
        this.alertSuccess();
        this.getTotalCount();
        this.getData(this.page,this.pageSize,this.search,this.statusPengajuan)
      }).catch(error => {
        loader.hide()
      })

    },
    tabChange(value) {
      switch (value) {
        case 'inputted':
            this.tab_selected.aria_selected_inputted = true;
            this.tab_selected.aria_selected_confirmed = false;
            this.statusPengajuan = 1;
            this.getData(this.page,this.pageSize,this.search,this.statusPengajuan);
        break;
        case 'confirmed':
            this.tab_selected.aria_selected_inputted = false;
            this.tab_selected.aria_selected_confirmed = true;
            this.statusPengajuan = 2;
            this.getData(this.page,this.pageSize,this.search,this.statusPengajuan);
        break;    
      }   
    },
    getTotalCount() {
      PengajuanUjianProfessionalService.countQuery().then(response => {
        let data = response.data;
        this.badges.totalInputted = data.anggotaInputted;
        this.badges.totalConfirmed = data.anggotaConfirmed;
      });
    },
    alertSuccess() {
      var vm = this;

      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan"
      });
    },
  },
  
}
</script>